import { Image } from "react-bootstrap"
import { thumbnailUrl } from "../api/rest"

export const ANONYMOUS_HANDLE = 'anonymous'
export const ANONYMOUS_EMAIL = 'anonymous@trubbl.com'

/**
 * Shorten string and add elipsis
 *
 * @param s
 * @param l
 * @param elipsis
 * @returns
 */
export function shorten(s, l, elipsis = "...") {
  if (s.length <= l) return s.trimEnd()
  s = s.substring(0, l)
  const t = Math.min(s.length, s.lastIndexOf(" "))
  return (t === 0 ? s : s.substring(0, t)).trimEnd() + elipsis
}

/**
 * Display user avatar and name
 *
 * @param {*} param0
 * @returns
 */
export function UserAvatar({ user, size = 25 }) {
  const name = user.name()

  if (!user.avatar)
    return <TextAvatar name={name} size={size} />

  return (
    <Image
      src={thumbnailUrl(user.avatar)}
      roundedCircle
      width={size}
      height={size}
      alt={name}
    />
  )
}

/**
 * Display a text avatar in the size specified
 * 
 * @param {*} param0 
 * @returns 
 */
function TextAvatar({ name, size }) {
  const initials = name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase();

  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.5 + 'px',
        fontFamily: "Verdana, sans-serif",
        fontWeight: 500,
        backgroundColor: '#c4cdd5'
      }}
    >
      {initials}
    </div>
  );
}